export const environment = {
  production: false,

  // API Configuration - OK to expose (public endpoints)
  apiBaseUrl: 'https://casco.mk/api/v3',

  // Stripe Publishable Key - OK to expose (designed to be public)
  // This is NOT the secret key - publishable keys are safe for frontend
  stripe_publishable_key: 'pk_test_51L56gjHyDlPSIKq7QqYzTTMgFYYjvC1WcHQElpSfINP2gZG9NH1zl7mdM4i7womRgAnmOx0O6741EzERJWAPjbt600hEaNMQYd',

  // iOS App Scheme for redirects - OK to expose (not sensitive)
  appScheme: 'com.feather.FeatherBarApp-DEV',

  // Auto-redirect timer (seconds)
  redirectDelaySeconds: 5,

  // Onboarding Configuration
  onboardingApiBaseUrl: 'https://casco.mk/api/v3',
  googleMapsApiKey: 'AIzaSyCFFMS1aFooTIa-tZ1L5RXq6RDGvqae8Yk', // Add Google Maps API key if using location picker

  // Auth Fragment Key
  authFragmentKey: 'a1b2c3d4e5f6071829304a5b6c7d8e9f0011223344556677aabbccddeeff0099',
};

// export const environment = {
//   production: false,

//   // API Configuration
//   apiBaseUrl: 'https://dashboard.featherapp.net/api/v3', 

//   // Stripe Publishable Key
//   stripe_publishable_key: 'pk_live_51L56gjHyDlPSIKq7WoCwJLWWpxOQOCkJKwF1kJZ29UTMCr0Q67Lpu62Q2NyXUWmNcSuSTXaauBJjsfK9FDMX3r2900e0nXrmbv',

//   // iOS App Scheme for redirects
//   appScheme: 'com.feather.FeatherBarApp',

//   // Auto-redirect timer (seconds)
//   redirectDelaySeconds: 5,

//   // Onboarding Configuration
//   onboardingApiBaseUrl: 'https://dashboard.featherapp.net/api/v3',
//   googleMapsApiKey: 'AIzaSyCFFMS1aFooTIa-tZ1L5RXq6RDGvqae8Yk', // Add Google Maps API key if using location picker
//   // Auth Fragment Key
//   authFragmentKey: 'a1b2c3d4e5f6071829304a5b6c7d8e9f0011223344556677aabbccddeeff0099',
// };
